<template>
  <div>
    <div class="content">
      {{balances["xrp"] | round(3) | delim}}
    </div>

    <div id="xrp_subtext" class="subtext">
    XRP
    </div>

    <div class="content">
      $ {{balances["usd"] | round(3) | delim}}
    </div>

    <div id="usd_subtext" class="subtext" v-if="xchg_rates['usd']">
    USD
    </div>

    <div class="content">
      € {{balances["eur"] | round(3)| delim}}
    </div>

    <div id="eur_subtext" class="subtext" v-if="xchg_rates['eur']">
    EUR
    </div>

    <div class="content">
      ₿ {{balances["btc"] | round(3) | delim}}
    </div>

    <div id="btc_subtext" class="subtext" v-if="xchg_rates['btc']">
    BTC
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountDetailsBalances',

  props : {
      balances : Object,
    xchg_rates : Object
  }
}
</script>

<style scoped>
#xrp_subtext,
#usd_subtext,
#eur_subtext,
#btc_subtext{
  color: #0c3df1; 
}
</style>
